import { PreviewResponse } from '@/hooks/queries/evaluations';
import { Evaluation } from '@/models/evaluations';

export const DEFAULT_ERRORS: Evaluation.FormErrors = {
  title: '',
  followersRange: '',
  platforms: ''
};

export const DEFAULT_PREVIEW_RESULTS: PreviewResponse = {
  totalPosts: 0,
  totalCreators: 0,
  totalKeywords: 0,
  totalKeywordGroups: 0,
  sponsoredPosts: 0,
  platforms: {
    instagram: {
      totalPosts: 0,
      postTypes: {
        post: 0,
        reel: 0,
        story: 0
      }
    },
    tiktok: {
      totalPosts: 0,
      postTypes: {
        post: 0,
        story: 0
      }
    },
    youtube: {
      totalPosts: 0,
      postTypes: {
        video: 0,
        short: 0,
        livestream: 0
      }
    }
  },
  keywordOccurrences: [
    {
      keyword: '',
      matchedPosts: 0
    }
  ]
};
